export default "__VITE_ASSET__dUOtRVpM__"